export const OPEN = 1;
export const TO_PLAN = 2;
export const IN_PROGRESS = 3;
export const ASSIGNED = 4;
export const REPORTED = 5;
export const CANCELLED = 6;

export default Object.freeze({
  OPEN,
  TO_PLAN,
  IN_PROGRESS,
  ASSIGNED,
  REPORTED,
  CANCELLED
});
